export default function fetchWithProgress(url, opts={}, onProgress) {
  return new Promise( (res, rej)=>{
    const xhr = new XMLHttpRequest();
    xhr.open(opts.method || 'get', url);
    for (const k in opts.headers||{})
      xhr.setRequestHeader(k, opts.headers[k]);
    xhr.onload = e => res(e.target.responseText);
    xhr.onerror = rej;
    if (xhr.upload && onProgress)
      xhr.upload.onprogress = onProgress;
    xhr.send(opts.body);
  });
}




// WEBPACK FOOTER //
// ./src/utils/FetchWithProgress.js